<table class="info-table">
  <tbody>
  <tr>
    <td>Tên tài khoản:</td>
    <td class="text-dark font-weight-semibold">{{ user.userName}}</td>
  </tr>
  <tr>
    <td>Loại tài khoản:</td>
    <td>
      <nz-tag nzColor="{{userRoleTypes|where:['value', user.userRole] | pluck: 'color'}}">{{ userRoleTypes|where:['value', user.userRole] | pluck: 'name' }}</nz-tag>
    </td>
  </tr>
  <tr>
    <td>Tên người dùng:</td>
    <td>{{ user.name }}</td>
  </tr>
  <tr>
    <td>Email:</td>
    <td>{{ user.email }}</td>
  </tr>
  <tr>
    <td>Số điện thoại:</td>
    <td>{{ user.phoneNumber }}</td>
  </tr>
  <tr>
    <td>Trạng thái:</td>
    <td>
      <nz-badge [nzStatus]="userStatus|where:['value', user.status] | pluck: 'badge'"
                [nzText]="userStatus|where:['value', user.status]|pluck: 'name'"></nz-badge>
    </td>
  </tr>
  <tr>
    <td>Lần đăng nhập cuối:</td>
    <td>{{user.lastLogin|dateFormat: SysDateFormat.DATE_TIME}}</td>
  </tr>
  </tbody>
</table>
